import Layout from '@4c/layout';

import React from 'react';
import PreviewItem from './PreviewItem';
import PreviewSizeContext from './PreviewSizeContext';
const ITEM_SPACING_PX = 10;
const styles = require('./PreviewRoll-styles.module.scss');

function PreviewRoll({
  activeIndex,
  children,
  itemSize = 100
}) {
  const fullPreviewSize = itemSize + ITEM_SPACING_PX;
  const marginLeft = -(activeIndex + 0.5) * fullPreviewSize;
  return React.createElement(PreviewSizeContext.Provider, {
    value: itemSize
  }, React.createElement("div", {
    className: styles.root
  }, React.createElement(Layout, {
    className: styles.container,
    style: {
      marginLeft
    }
  }, children)));
}

PreviewRoll.Item = PreviewItem;
export default PreviewRoll;